import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null = loading, false = anon, obj = user
  const [authOpen, setAuthOpen] = useState(false);
  const [authReason, setAuthReason] = useState("");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback((userObj) => {
    setUser(userObj);
    setAuthOpen(false);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.debug("Logout request failed:", e?.message); }
    setUser(false);
  }, []);

  const requireAuth = useCallback((reason = "") => {
    if (user && user.email) return true;
    setAuthReason(reason);
    setAuthOpen(true);
    return false;
  }, [user]);

  const value = useMemo(
    () => ({ user, setUser, refresh, login, logout, requireAuth, authOpen, setAuthOpen, authReason }),
    [user, refresh, login, logout, requireAuth, authOpen, authReason]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
